import { Box, SimpleGrid } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { FormNumberInput } from "./FormNumberInput";
import { InvoiceFromOcrDto } from "@/api/invoiceApi";
import { Heading } from "@digital-services-gard-as/anchor-react";
import { MemberDetailsDto, InvoiceFormData } from "@/types";

type Props = {
    invoiceRecipient: MemberDetailsDto | undefined;
    ocrResponse?: InvoiceFromOcrDto;
    crmId?: string;
};

export const OtherExpenses = ({ invoiceRecipient, ocrResponse, crmId }: Props) => {
    const { t } = useTranslation("invoices");
    const {
        watch,
        control,
        formState: { errors }
    } = useFormContext<InvoiceFormData>();
    const currency = watch("bankAccount.currency");

    const vatDisabled =
        invoiceRecipient?.vatNumber === "" || (invoiceRecipient?.vatNumber === undefined && Boolean(crmId));

    const customVatCompareValue = vatDisabled
        ? ((ocrResponse?.totalVatAmount ?? 0) + (ocrResponse?.totalLocalTax ?? 0)).toString()
        : undefined;

    return (
        <Box bg="white" p={{ base: "1rem", md: "1.5rem" }} borderRadius="md" boxShadow="xs">
            <Heading size="md" style={{ marginBottom: "0.5rem" }}>
                {t("invoices:createInvoice.feesAndExpenses.otherExpenses")}
            </Heading>
            {/*eslint-disable-next-line no-magic-numbers*/}
            <SimpleGrid columns={{ base: 1, md: 2 }} gap={4}>
                <FormNumberInput
                    id="otherExpenses"
                    label={t("invoices:createInvoice.feesAndExpenses.otherExpenses")}
                    isRequired={false}
                    errorMessage={errors.otherExpenses?.message}
                    control={control}
                    currency={currency}
                />
                <FormNumberInput
                    id="claimSettlements"
                    label={t("invoices:createInvoice.feesAndExpenses.claimSettlements")}
                    isRequired={false}
                    errorMessage={errors.claimSettlements?.message}
                    control={control}
                    currency={currency}
                />
                <FormNumberInput
                    id="totalVatAmount"
                    label={t("invoices:createInvoice.feesAndExpenses.totalAmountVAT")}
                    isRequired={false}
                    errorMessage={errors.totalVatAmount?.message}
                    control={control}
                    currency={currency}
                    isDisabled={vatDisabled}
                />
                <FormNumberInput
                    id="totalLocalTax"
                    label={t("invoices:createInvoice.feesAndExpenses.totalAmountLocalTaxes")}
                    isRequired={false}
                    errorMessage={errors.totalLocalTax?.message}
                    control={control}
                    currency={currency}
                    customCompareValue={customVatCompareValue}
                />
            </SimpleGrid>
        </Box>
    );
};
